import { lazy } from "react";
import type { RouteObject } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { AuthRouteLayout } from "@/src/auth/layouts/auth-route-layout";
import { ErrorRouteBoundary } from "@/src/common/components/error-route-boundary";

const AcceptInvitePage = lazy(() => import("@/src/auth/pages/accept-invite-page"));
const AuthPage = lazy(() => import("@/src/auth/pages/auth-page"));

export const authRoutes: RouteObject = {
	element: <AuthRouteLayout />,
	errorElement: <ErrorRouteBoundary />,
	children: [
		{ path: AUTH_ROUTES.ACCEPT_INVITE, element: <AcceptInvitePage /> },
		{ path: AUTH_ROUTES.AUTH, element: <AuthPage /> },
	],
};
